// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";

Mapy.MarkerGEO = function(coords) {
	var options = {}
	var span = node("span", {className: "geolocation-mark" });
	options.url = span;
	options.anchor = {left:10, top:10};
	
	SMap.Marker.call(this, coords, null, options);
}

Mapy.MarkerGEO.prototype = Object.create(Object.assign({}, SMap.Marker.prototype));
